class Checkout {
  constructor() {
    this.listenToCheckoutCartItemSelectChanges();
    this.listenToCheckoutOptionChanges();
    this.listenToCheckoutCartItemRemoveClick();
    this.listenTransitionButtons();
  }

  listenToCheckoutCartItemSelectChanges() {
    document
      .querySelectorAll('.checkout-cart-item__select')
      .forEach(element => {
        element.addEventListener('change', e => {
          const switchUrl = e.target.dataset.switchUrl;
          const selectedOption = e.target.querySelector('option:checked');

          this.submitForm(
            `${switchUrl.replace('__id__', selectedOption.dataset.id)}`
          );
        });
      });
  }

  listenToCheckoutOptionChanges() {
    Array.from(document.querySelectorAll('.checkout-option')).forEach(element =>
      element.addEventListener('click', e => {
        this.submitForm(e.currentTarget.dataset.url);
      })
    );

    Array.from(
      document.querySelectorAll('.checkout-option__add-button')
    ).forEach(element =>
      element.addEventListener('click', e => {
        this.submitForm(e.target.dataset.url);
      })
    );

    Array.from(
      document.querySelectorAll('.checkout-option__collapse-button')
    ).forEach(button => {
      button.addEventListener('click', function () {
        this.classList.toggle('checkout-option__collapse-button--open');

        const outer = this.closest('.checkout-option__outer');

        const collapseBody = outer.querySelector(
          '.checkout-option__collapse-body'
        );

        collapseBody.classList.toggle('checkout-option__collapse-body--open');
      });
    });
  }

  showLoader() {
    const loaderSelector = 'page__loader';
    document
      .querySelector(`.${loaderSelector}`)
      .classList.add(`${loaderSelector}--visible`);
  }

  submitForm(action) {
    const form = document.createElement('form');
    const csrfToken = document.head.querySelector(
      'meta[name="csrf-token"]'
    ).content;

    this.showLoader();

    form.method = 'post';
    form.action = `${action}?_token=${csrfToken}`;

    document.body.appendChild(form);
    form.submit();
  }

  listenToCheckoutCartItemRemoveClick() {
    document.querySelectorAll('.checkout-cart-item__remove').forEach(element =>
      element.addEventListener('click', e => {
        if (!confirm(e.target.dataset.message)) {
          e.preventDefault();
        }
      })
    );
  }

  listenTransitionButtons() {
    const checkoutForm = document.querySelector('.checkout-form');

    if (checkoutForm && 'payment-form' !== checkoutForm.id) {
      checkoutForm.addEventListener('submit', () => this.showLoader());
    }
  }
}

export default Checkout;
